import React from "react";
import "./Agreement.css";

function Agreement() {
  return (
    <div style={{ padding: "20px", margin: "20px", height: "100%" }}>
      <p className="title">Aviso de privacidad</p>
      <p className="p">Estimados Médicos (en lo sucesivo los “Titulares”):</p>
      <p className="p">
        Por medio del presente se le informa que el Aviso de Privacidad ha sido
        realizado en apego a la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares, su Reglamento y a los Lineamientos
        Generales en Materia de Protección de Datos Personales (“las
        disposiciones legales”).
      </p>
      <p className="p">Hacemos de su conocimiento lo siguiente:</p>
      <p className="title">
        Responsable(s) del tratamiento de datos personales:
      </p>
      <p className="p">
        Las empresas Exeltis Pharma México, S.A. de C.V. y Atrare Consultores S.
        de R.L. de C.V. (conjuntamente referidos como{" "}
        <span className="bold">“Los Responsables”</span>), serán las
        responsables del tratamiento y resguardo de los datos personales que
        usted nos proporcione mediante esta aplicación (App) y Sitio web, los
        cuales serán protegidos conforme a lo dispuesto por la Ley Federal de
        Protección de Datos Personales en Posesión de Particulares.
      </p>
      <p className="title">
        Aceptación del aviso de privacidad y consentimiento de los Titulares:
      </p>
      <p className="p">
        Al hacer entrega de sus datos personales por cualquier medio, ya sea
        electrónico o físico, <span className="bold">los Titulares</span>{" "}
        aceptan y otorgan su consentimiento a{" "}
        <span className="bold">Los Responsables</span> y sus empresas filiales
        y/o subsidiarias a utilizar y tratar de forma automatizada sus datos
        personales e información suministrados, los cuales pasarán a formar
        parte de las bases de datos de{" "}
        <span className="bold">Los Responsables</span> y de las empresas
        filiales y/o subsidiarias correspondientes.
      </p>
      <p className="title">Datos personales sujetos al tratamiento:</p>
      <p className="p">
        Los datos personales que serán recabados conforme a lo establecido en el
        presente aviso de privacidad serán los siguientes:
      </p>
      <p className="p">
        • Datos de identificación. A saber: nombre y apellidos, género, firma
        (autógrafa o electrónica).
      </p>
      <p className="p">
        • Datos de contacto. A saber: nombre, domicilio, teléfono, correo
        electrónico.
      </p>
      <p className="p">
        • Información relacionada con su profesión. A saber: ocupación,
        especialidad, cédula profesional.
      </p>
      <p className="p">
        No se recabarán datos personales sensibles de{" "}
        <span className="bold">los Titulares.</span>
      </p>
      <p className="p">
        Sus datos personales no se vincularán directamente con la información de
        uso de nuestro producto, ya que usted quedará registrado con un código
        de identificación.
      </p>
      <p className="title">Finalidades del tratamiento:</p>
      <p className="p">
        Los datos personales serán utilizados para las siguientes finalidades:
      </p>
      <p className="p">
        • Para invitarlo a participar en el Programa de Experiencia Clínica
        Temprana del Suplemento alimenticio a base de SPM´s, Omega 3, Colágeno
        nativo tipo II sin desnaturalizar (UC-II) y Astaxantina.
      </p>
      <p className="p">
        • Para la creación y uso de una cuenta en la App y Sitio web.
      </p>
      <p className="p">
        • Para permitirle prestar servicios relacionados con el diagnóstico
        médico, la prestación de asistencia sanitaria, tratamiento médico o la
        gestión de servicios sanitarios.
      </p>
      <p className="p">
        • Para temas de control de calidad y atención al cliente.
      </p>
      <p className="p">
        • Para recopilar la información de los pacientes en la App y Sitio web.
      </p>
      <p className="p">
        • Para ponernos en contacto con usted, en caso de reportar algún efecto
        secundario y nos pueda proporcionar más información al respecto.
      </p>
      <p className="title">Resguardo y conservación de los datos personales:</p>
      <p className="p">
        Se hace del conocimiento de <span className="bold">los Titulares</span>{" "}
        que sus datos personales podrán ser incluidos en una base de datos y
        serán tratados, según el grupo de interés respectivo, para las
        finalidades anteriormente previstas.
      </p>
      <p className="p">
        En caso de que <span className="bold">los Titulares</span> no estén de
        acuerdo con el uso de sus datos personales para una o varias de las
        finalidades anteriores, podrán solicitar la limitación del uso de sus
        datos personales, para lo cual deberán enviar un correo electrónico a la
        siguiente dirección: contacto@atrareconsultores.com.mx.
      </p>
      <p className="title">Transferencia de datos personales: </p>
      <p className="p">
        Sus datos personales podrán ser remitidos o transferidos a empresas
        filiales o del grupo comerciales de{" "}
        <span className="bold">Los Responsables</span> conforme a los supuestos
        permitidos por las disposiciones legales en materia de protección de
        datos personales o en los demás supuestos establecidos por la
        legislación aplicable.{" "}
      </p>
      <p className="p">
        Para obtener mayor información relacionada con la remisión o transmisión
        de sus datos personales, lo invitamos a contactarnos a través del correo
        electrónico mencionado en el presente Aviso de Privacidad.
      </p>
      <p className="title">
        Medios para el ejercicio de sus derechos ARCO o para revocar su
        consentimiento:
      </p>
      <p className="p">
        Usted tiene derecho a conocer con qué datos contamos, para qué los
        utilizamos y las condiciones del uso que les daremos (acceso). Asimismo,
        es su derecho solicitar la corrección de su información personal en caso
        de que esté desactualizada, sea inexacta o incompleta (rectificación);
        que la eliminemos de nuestros registros o bases de datos cuando
        considere que la misma no está siendo utilizada adecuadamente
        (cancelación); así como oponerse al uso de sus datos personales para
        fines específicos (oposición). Estos derechos se conocen como derechos
        ARCO.
      </p>
      <p className="p">
        Para el ejercicio de cualquiera de los derechos ARCO, usted deberá
        presentar la solicitud respectiva a través del siguiente medio:
      </p>
      <p className="p">
        Correo electrónico y/o presentación de forma escrita o personal.
      </p>
      <p className="p">contacto@atrareconsultores.com.mx</p>
      <p className="p">
        Privada Miguel Ángel #2, Col. Nonoalco, C.P. 03700, Benito Juárez, CDMX
      </p>
      <p className="p">Teléfono: +52 55 5611 6250</p>
      <p className="p">
        Para mayor detalle sobre el uso de la información y acerca de los
        Derechos ARCO, usted puede ingresar a los portales de nuestras empresas.
        https://www.exeltis.com.mx/aviso.html y
        http://atrare.com.mx/aviso-de-privacidad#anchor3.
      </p>
      <p className="title">Medidas de seguridad: </p>
      <p className="p">
        Los datos personales serán mantenidos en la más estricta
        confidencialidad y serán resguardados de manera adecuada.
      </p>
      <p className="p">
        Para ello <span className="bold">Los Responsables</span> han
        implementado y mantienen las medidas de seguridad, técnicas,
        administrativas y físicas necesarias para proteger sus datos personales
        y evitar su pérdida, alteración, destrucción o el uso, acceso o
        tratamiento no autorizado.
      </p>
      <p className="title">Cambios a este Aviso de Privacidad: </p>
      <p className="p">
        Cualquier cambio o actualización a este Aviso de Privacidad serán
        publicados a través de nuestra página web o a través del correo
        electrónico que nos haya proporcionado.
      </p>
      <p className="title">
        Consentimiento para el tratamiento de datos personales:{" "}
      </p>
      <p className="p">
        Para efectos de lo dispuesto en las disposiciones legales en materia de
        protección de datos personales,{" "}
        <span className="bold">los Titulares</span> manifiestan lo siguiente:
      </p>
      <p className="p">
        • que otorga su consentimiento para la recolección, tratamiento y uso de
        sus datos personales desde el momento en que los ha proporcionado por
        primera vez hasta la conclusión de su relación con{" "}
        <span className="bold"> Los Responsables;</span>
      </p>
      <p className="p">
        • que el presente Aviso le ha sido dado a conocer por{" "}
        <span className="bold"> Los Responsables;</span> y
      </p>
      <p className="p">
        • que ha leído, entendido y aceptado los términos expuestos en este
        Aviso de Privacidad para la recolección, obtención, almacenamiento,
        divulgación, transferencia, tratamiento y uso de sus datos personales.
      </p>
      <p style={{ marginBottom: "20px" }}></p>
    </div>
  );
}

export default Agreement;
